import React, {useEffect} from 'react';
import PropTypes from 'prop-types';

import './little-quote.scss';

const LittleQuote = ({quote}) => {

  
  useEffect(() => {
    const names = quote.author.split("");
  }, [])

  return (
    <div key={1} className="quote">
      <h3>{quote.phrase}</h3>
      <h5>{quote.author}</h5>
    </div>
  );
}

LittleQuote.propTypes = {};

export default LittleQuote;
